/**
 * API client for allocation endpoints
 */

import { apiClient } from '../../../shared/api/axiosClient';

export interface AdminCancelAllocationRequest {
  cancellationNotes?: string;
}

/**
 * Cancel an allocation via the new pricework module endpoint.
 * Self-cancel by the owner is allowed without permission;
 * cross-cancel requires allocations.cancel or legacy allocations.admin.cancel.
 *
 * Replaces the legacy POST /api/v1/allocations/{id}/admin-cancel route, which
 * returned a populated body — the new route returns 200 OK with no body.
 *
 * @param allocationId - The unique identifier of the allocation to cancel
 * @param cancellationNotes - Optional notes for the cancellation
 */
export async function adminCancelAllocation(
  allocationId: string,
  cancellationNotes?: string
): Promise<void> {
  const request: AdminCancelAllocationRequest = {
    cancellationNotes,
  };

  await apiClient.post(
    `/pricework/api/v1/allocations/${allocationId}/cancel`,
    request
  );
}
